export default "__VITE_ASSET__BbSeOrrc__"